import { FamilyStepOptionDto } from "@lib/dtos/monitoring/family/family-step-option.dto";

export enum SubType {
  W = "W",
  A = "A",
  RS = "RS",
}

export class FamilyStepOption extends FamilyStepOptionDto {
  constructor(
    devices: string[],
    groupName: string,
    quantityMin: number,
    quantityMax: number,
    filter1?: string,
    filter2?: string,
    subType?: string,
    groupImageCantoID?: string,
    description?: string,
    piSheetURL?: string,
    configurationURL?: string,
  ) {
    super();
    this.devices = devices;
    this.groupName = groupName;
    this.quantityMin = quantityMin;
    this.quantityMax = quantityMax;
    this.filter1 = filter1;
    this.filter2 = filter2;
    this.subType = subType;
    this.groupImageCantoID = groupImageCantoID;
    this.description = description;
    this.piSheetURL = piSheetURL;
    this.configurationURL = configurationURL;
  }
}
